export default "__VITE_ASSET__BUwjqNIa__"